import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import LogoTicker from "@/components/landing/LogoTicker";
import TrustBanner from "@/components/landing/TrustBanner";
import Features from "@/components/landing/Features";
import HowItWorks from "@/components/landing/HowItWorks";
import WhatsAppShowcase from "@/components/landing/WhatsAppShowcase";
import CalendarShowcase from "@/components/landing/CalendarShowcase";
import FAQ from "@/components/landing/FAQ";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import DemoModal from "@/components/landing/DemoModal";

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false);

  const openDemo = () => setDemoOpen(true);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-base text-slate-100 overflow-x-hidden">
      <Navbar onDemoClick={openDemo} />
      <main>
        <Hero onDemoClick={openDemo} />
        <LogoTicker />
        <TrustBanner />
        <Features />
        <HowItWorks />
        <WhatsAppShowcase />
        <CalendarShowcase />
        <FAQ />
        <CTASection onDemoClick={openDemo} />
      </main>
      <Footer onDemoClick={openDemo} />
      <DemoModal open={demoOpen} onOpenChange={setDemoOpen} />
    </div>
  );
}
